module.exports = __webpack_public_path__ + "static/img/7.9bce340.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/7.png
// module id = oUT3
// module chunks = 0